import { Text } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { color, fontSize, fontWeight, letterSpacing, space, textAlign, width } from 'styled-system'
import { theme } from '../../theme'
import { StyledSystemProps } from '../../typings/StyledSystemProps'

type Props = StyledSystemProps & {
  cursor?: string
  textTransform?: any
  color?: string
  as?: any
}

const Span = styled(Text)<Props>`
  ${space};
  ${color};
  ${width};
  ${fontSize};
  ${textAlign};
  ${fontWeight};
  ${letterSpacing};
  text-transform: ${(props: Props) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: Props) => props.cursor};
  }
`

export default Span

Span.defaultProps = {
  pointer: 'default',
  fontSize: '14px',
  lineHeight: '20px',
  as: 'span',
  color: theme.colors.text.default
}
